import { z } from 'zod';

export const DataplaneHealthStatus = z.array(z.looseObject({})).optional();
export type DataplaneHealthStatusType = z.infer<typeof DataplaneHealthStatus>;
